<template>
  <v-dialog
      v-model="dialog"
      max-width="320"
      persistent
  >
    <v-list
        class="py-2"
        color="primary"
        elevation="12"
        rounded="lg"
    >
      <v-list-item
          prepend-icon="$vuetify-outline"
          title="دریافت اطلاعات از سرور"
      >
        <template v-slot:prepend>
          <div class="pe-4">
            <v-icon color="primary" size="x-large"></v-icon>
          </div>
        </template>

        <template v-slot:append>
          <v-progress-circular
              color="primary"
              indeterminate="disable-shrink"
              size="16"
              width="2"
          ></v-progress-circular>
        </template>
      </v-list-item>
    </v-list>
  </v-dialog>
  <div class="text-center pa-4" style="direction: rtl">
    <v-dialog
        v-model="dialog1"
        max-width="400"
        persistent
    >
      <v-card
          prepend-icon="mdi-delete"
          text="آیا از حذف این محصول مطمئن هستید؟"
          title="حذف از سبد خرید"
          style="direction: rtl"
      >
        <template v-slot:actions>
          <v-spacer></v-spacer>



          <v-btn @click="deleteItemTrue()">
            بله
          </v-btn>
          <v-btn @click="dialog1 = false">
            خیر
          </v-btn>
        </template>
      </v-card>
    </v-dialog>
  </div>
  <div class="text-center pa-4" style="direction: rtl">
    <v-dialog
        v-model="dialogedit"
        max-width="400"
        persistent
    >
      <v-card
          prepend-icon="mdi-basket"
          title="ویرایش سفارش"
          style="direction: rtl"
      >
        <div style="padding: 0 20px">
          <div class="col-2 float-right">
            <div style="font-size: 18px;color: #fff;background: #1fa29d;margin: 0 5px;text-align: center;border-radius: 10px;height: 38px;padding-top: 5px;" @click="plus"><i class="fa-solid fa-plus"></i> </div>
          </div>
          <div class="col-8 float-right">
            <div class="form-group" style="text-align: center;position: relative">
              <input type="text" class="form-control" style="text-align: center;height: 38px;padding-top: 5px;padding-left: 92px;" v-model="value_basket" @change="changeN"/>
              <h5 style="position: absolute;top: 3px;left: 8px;" v-text="itemSelect.product.uint_title"></h5>
            </div>
          </div>
          <div class="col-2 float-right">
            <div style="font-size: 18px;color: #fff;background: #7a0606;margin: 0 5px;text-align: center;border-radius: 10px;height: 38px;padding-top: 5px;" @click="minus"><i class="fa-solid fa-minus"></i> </div>
          </div>
          <div class="col-12 float-right" style="margin: 10px auto">
            <div class="btn btn-success" style="width: 100%;background: #1fa29d;" @click="addtoBasket(itemSelect.product)">ویرایش </div>
          </div>
        </div>
        <template v-slot:actions>
          <v-spacer></v-spacer>
        </template>
      </v-card>
    </v-dialog>
  </div>
  <div class="main">
    <template  v-if="baskets.data.priceTotal > 0">
      <div class="col-12" style="background: #1fa29d;padding: 10px;color: #fff">
        <div class="col-4 float-right">مبلغ کل سفارش :</div>
        <div class="col-8 float-right text-left" style="padding-left: 15px">{{baskets.data.priceTotalShow}} ریال</div>
        <div class="clearfix"></div>
      </div>
      <template v-for="(basket, index)  in baskets.data.items" :key="index">
        <div class="col-12 item" >
          <div class="col-12" style="padding: 5px;border-bottom: 1px solid #fff">
            <div class="col-2 float-right" style="">
              <img :src="basket.product.img_url" width="100%" style="border-radius: 5px;overflow: hidden">
            </div>
            <div class="col-10 float-right" style="padding: 10px">
              <h2 style="font-size: 0.9rem;font-weight: bold" v-text="basket.product.cat_title+' '+basket.product.title"></h2>
              <h3 style="font-size: 0.6rem;font-weight: bold;color: #8c8c8c" v-text="'دسته بندی : '+basket.product.cat_title"></h3>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="col-12" v-if="basket.product.composition_id!=10" style="padding: 5px;border-bottom: 1px solid #fff;color: #262626;font-size: 0.8rem">
            <div class="col-6 float-right" style="border-left: 1px solid #fff;padding: 0 10px;padding: 10px">
              <div class="col-6 float-right text-right">کد کالا :</div>
              <div class="col-6 float-right text-left">{{basket.product.title}}</div>
            </div>
            <div class="col-6 float-right" style=";padding-right: 5px;padding: 10px">
              <div class="col-6 float-right text-right">رنگ کالا :</div>
              <div class="col-6 float-right text-left" v-if="basket.product.category.parent_name!=null">{{basket.product.category.title}}</div>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="col-12" style="padding: 5px;border-bottom: 1px solid #fff;color: #262626;font-size: 0.8rem">
            <div class="col-6 float-right" style="border-left: 1px solid #fff;padding: 0 10px;padding: 10px" v-if="basket.product.composition_id!=10">
              <div class="col-6 float-right text-right">مقدار‌ :</div>
              <div class="col-6 float-right text-left">{{basket.val}} <span class="uint_title">{{basket.product.uint_title}}</span></div>
            </div>
            <div class="col-12 float-right" style="padding: 0 10px;padding: 10px" v-else>
              <div class="col-6 float-right text-right">مقدار‌ :</div>
              <div class="col-6 float-right text-left">{{basket.val}} <span class="uint_title">{{basket.product.uint_title}}</span></div>
            </div>
            <div class="col-6 float-right" v-if="basket.product.composition_id!=10" style=";padding-right: 5px;padding: 10px">
              <div class="col-6 float-right text-right">نوع سفارش :</div>
              <div class="col-6 float-right text-left"></div>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="col-12" style="padding: 5px;border-bottom: 1px solid #fff;color: #262626;font-size: 0.8rem">
            <div class="col-12 float-right" style=";padding: 0 10px;padding: 10px">
              <div class="col-4 float-right text-right">قیمت واحد :</div>
              <div class="col-8 float-right text-left">{{basket.product.price_dis_format}} <span class="uint_title">ریال</span></div>
            </div>

            <div class="clearfix"></div>
          </div>
          <div class="col-12" style="padding: 5px;border-bottom: 1px solid #fff;color: #1fa29d;font-size: 0.8rem">
            <div class="col-12 float-right" style=";padding: 0 10px;padding: 10px">
              <div class="col-4 float-right text-right">جمع آیتم :</div>
              <div class="col-8 float-right text-left">{{basket.price_dis_format}} <span class="uint_title">ریال</span></div>
            </div>

            <div class="clearfix"></div>
          </div>
          <div class="col-12" v-if="(basket.price_discount - basket.price) >0" style="padding: 5px;border-bottom: 1px solid #fff;color: #880000;font-size: 0.8rem">
            <div class="col-12 float-right" style=";padding: 0 10px;padding: 10px;">
              <div class="col-4 float-right text-right" style="font-size: 0.5rem">تخفیف سفارش از اپلیکیشن :</div>
              <div class="col-8 float-right text-left">{{showFormat(basket.price_discount - basket.price)}} <span class="uint_title">ریال</span></div>
            </div>

            <div class="clearfix"></div>
          </div>
          <div class="col-12" style="padding: 5px;border-bottom: 1px solid #fff;color: #1fa29d;font-size: 0.8rem">
            <div class="col-12 float-right" style=";padding: 0 10px;padding: 10px">
              <div class="col-4 float-right text-right">جمع نهایی آیتم :</div>
              <div class="col-8 float-right text-left">{{basket.price_format}} <span class="uint_title">ریال</span></div>
            </div>

            <div class="clearfix"></div>
          </div>
          <div class="col-12" style="color: #fff;font-size: 0.8rem;text-align: center">
              <div class="col-6 float-right text-center" v-if="basket.product.composition_id!=10" @click="edit(basket)" style="background: #faec00;padding: 10px;color: #000"><i class="fa-solid fa-pen-to-square"></i> ویرایش</div>
              <div class="col-6 float-right text-center" v-if="basket.product.composition_id!=10" style="background: #5b0000;padding: 10px" @click="deleteItem(basket.id)" ><i class="fa-solid fa-trash"></i> حذف سفارش</div>
              <div class="col-12 float-right text-center" v-if="basket.product.composition_id==10" style="background: #5b0000;padding: 10px" @click="deleteItem(basket.id)" ><i class="fa-solid fa-trash"></i> حذف سفارش</div>
            <div class="clearfix"></div>
          </div>
        </div>
      </template>
      <div  style="position: fixed;width: 100%;margin: 0 auto;bottom: 0;;text-align: center;bottom: 54px" >
        <div class="col-6 float-right text-center" @click="showhome" style="background: #001280;padding: 10px;color: #fff">افزودن محصول جدید</div>
        <div class="col-6 float-right text-center" @click="showcheckout" style="background: #005751;padding: 10px 10px 15px;color: #fff"  >مرحله بعدی سفارش</div>
        <div class="clearfix"></div>
      </div>
    </template>
    <template  v-else>
      <div style="padding: 30px 15px">
        <div class="col-12" style="display: flex;align-content: center;justify-content: center;direction: rtl;padding: 5px;text-align: center;color: #1fa29d">
          سبد خرید خالی است
        </div>
      </div>
    </template>
  </div>
</template>


<script >
import {defineComponent} from "vue";
import HeaderApp from "@/views/headerApp.vue";
import FooterApp from "@/views/FooterApp.vue";
import http from "@/plugins/axios";
import router from "@/router";
import {formToJSON} from "axios";
var numeral = require("numeral");
export default defineComponent({
  name: 'cart-docwin',
  components: {FooterApp, HeaderApp},
  data: () => ({
    dialog: true,
    dialog1: false,
    dialogedit: false,
    value_basket : "1.0",
    itemSelect : [],
    baskets :  {
      data: [],
      total: [],
    },
    deleteItemid : 0,
    sum : 1000,

  }),
  methods: {
    addtoBasket(product){
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.post("/basket/add",{
        product_id : product.id,
        val : this.value_basket,
      }, { headers: { Authorization: AuthStr ,"Content-type": "multipart/form-data"} })
          .then(response => {
            this.isLoading = false;
            this.dialog1 =false;
            this.$toast.success("محصول با موفقیت به سبد خرید ویرایش شد.", {

              theme: "toasted-primary",
              position: "top-right",
              duration : 5000,

            });
            this.getCart();
            this.dialogedit=false;
          })
          .catch((error) => {

          });
    },
    changeN(){
      this.value_basket =parseFloat(this.value_basket)
      this.value_basket = this.value_basket.toFixed(1);
      if(this.value_basket=="NaN")
        this.value_basket = 1.0;
      if(this.value_basket<=0.5){
        this.value_basket = "0.5";
      }
    },
    plus(){
      this.value_basket =parseFloat(this.value_basket)+0.1;
      this.value_basket = this.value_basket.toFixed(1);

    },
    minus(){
      this.value_basket =parseFloat(this.value_basket)-0.1;
      this.value_basket = this.value_basket.toFixed(1);
      if(this.value_basket<=0.5){
        this.value_basket = "0.5";
      }
    },
    edit(item){
      this.value_basket =item.val;
      this.dialogedit= true;
      this.itemSelect = item;
    },
    showcheckout(){
      router.push("/checkout")
    },
    showhome(){
      router.push("/home")
    },
    showFormat(price){
      return numeral(price).format("0,0");
    },
    deleteItemTrue(){
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.post("/basket/delete",{
        basket_id : this.deleteItemid,
      }, { headers: { Authorization: AuthStr ,"Content-type": "multipart/form-data"} })
          .then(response => {
            this.dialog1=false;
            this.$toast.success("محصول با موفقیت از سبد خرید حذف شد.", {

              theme: "toasted-primary",
              position: "top-right",
              duration : 5000,

            });
            this.getCart();
          })
          .catch((error) => {

          });
    },
    deleteItem(id){
      this.dialog1=true;
      this.deleteItemid = id;
    },
    getCart() {
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/basket/get", { headers: { Authorization: AuthStr } })
          .then(response => {
            this.baskets = response.data;
            this.dialog= false;
            console.log( this.baskets.data);
          })
          .catch((error) => {
          });
    },
  },
  mounted() {
    this.getCart();
  },
  props: [
    "show",
  ],
});
</script>


<style scoped>
.main{
  direction: rtl;
  padding: 28px 0 100px;
  height: calc(100% +100px);
}
.col-12.item {
  width: 94vw;
  margin: 10px;
  background: #e5e5e5;
}
</style>